// extracted by mini-css-extract-plugin
export var ratingItem = "RatingItem-module--ratingItem--dce5a";
export var ratingStar = "RatingItem-module--ratingStar--6abb1";
export var ratings = "RatingItem-module--ratings--86841";
export var ratingsName = "RatingItem-module--ratingsName--98009";